const cinema = (function ($) {
    window.dataLayer = window.dataLayer || [];

    const codeGeneration = {
        availableVoucher: 0,
        httpStatusCode: {
            Unauthorised: '401',
            Forbidden: '403',
        },
        elements: {
            continueCodeGenerationButton: '#continue-code-generation-cta',
            radioButton1: '#radio-button-1',
            radioButton2: '#radio-button-2',
            loadingSpinner: '#generate-code-loading-modal',
            numberOfTickets: '#ticket-amount',
            codeGenerationErrorModel: '#generate-voucher-code-error',
            sessionTimeOutErrorModel: '#session-timeout-error-model',
            codeGenerationErrorModelClose:
                '#generate-voucher-code-error .vds-modal__close',
            sessionTimeOutErrorModelClose:
                '#session-timeout-error-model .vds-modal__close',
            codeGenerationErrorModelCloseButton: '#generate-voucher-code-error-close',
            sessionTimeOutErrorModelCloseButton: '#session-timeout-error-model-close',
            codeGenerationModel: '#generate-cinema-code-modal',
            codeGenerationSuccessModel: '#generate-code-success-modal',
            copyCinemaCodeButton: '#cinema-code-copy-button',
            getYourTicketsButton: '#get-your-tickets',
            cinemaFaqAccordion: '#cinema-faq-accordion .vds-accordion__link',
            cinemaVoucherCodeAccordion:
                '#cinema-vouchercode-accordion .vds-accordion__link',
            availableTicketCount: '#cinema-available-tickets',
            generatedCodesBody: '#generated-code-body',
        },
        class: {
            disableButton: 'vds-button--disabled',
        },
        urls: {
            error: '/error/error-page',
        },
        func: {
            bindings: function () {
                $(codeGeneration.elements.radioButton1).on(
                    'change',
                    codeGeneration.func.continueCodeGeneration.isSubmissionValid
                );
                $(codeGeneration.elements.radioButton2).on(
                    'change',
                    codeGeneration.func.continueCodeGeneration.isSubmissionValid
                );
                $(codeGeneration.elements.numberOfTickets).on(
                    'change',
                    codeGeneration.func.continueCodeGeneration.isSubmissionValid
                );
                $(codeGeneration.elements.continueCodeGenerationButton).on(
                    'click',
                    codeGeneration.func.continueCodeGeneration.submit
                );
                $(codeGeneration.elements.getYourTicketsButton).on(
                    'click',
                    codeGeneration.func.getYourTicket
                );
                codeGeneration.func.bindFAQId();
                $(codeGeneration.elements.cinemaVoucherCodeAccordion).on(
                    'click',
                    codeGeneration.func.gtm.pushVoucerCodeAccordionEventDetails
                );
            },
            bindFAQId: function () {
                let faqCount = 1;
                $(codeGeneration.elements.cinemaFaqAccordion).on(
                    'click',
                    codeGeneration.func.gtm.pushFaqAccordionEventdetails
                );
                $(codeGeneration.elements.cinemaFaqAccordion).each(function () {
                    $(this).attr('id', 'FAQ-' + faqCount);
                    faqCount++;
                });
            },
            init: function () {
                codeGeneration.func.bindings();
            },
            getYourTicket: function () {
                window.dataLayer.push({
                    event: 'cinemaCode',
                    stepCategory:
                        $(codeGeneration.elements.availableTicketCount).data('value') > 1
                            ? 'multiCode'
                            : 'singleCode',
                    stepTitle: 'getCinemaCode',
                });
                return openModal('generate-cinema-code-modal');
            },
            continueCodeGeneration: {
                voucherType: '',
                submit: function () {
                    if (codeGeneration.func.continueCodeGeneration.isSubmissionValid()) {
                        $(codeGeneration.elements.codeGenerationModel).hide();
                        $(codeGeneration.elements.loadingSpinner).show();
                        codeGeneration.func.continueCodeGeneration.voucherType =
                            codeGeneration.func.continueCodeGeneration.getSelectedVoucherType();
                        codeGeneration.func.gtm.pushGenerateCodeEventDetails();
                        $.ajax({
                            type: 'GET',
                            url: '/api/sitecore/CinemaTickets/IssueVoucher',
                            data: {
                                numberOfVouchers:
                                    codeGeneration.func.continueCodeGeneration.getNumberOfVouchers(),
                                VoucherType:
                                    codeGeneration.func.continueCodeGeneration.getSelectedVoucherType(),
                            },
                            success: codeGeneration.func.continueCodeGeneration.onSuccess,
                            error: codeGeneration.func.onError,
                        });
                    }
                },
                onSuccess: function (data) {
                    $(codeGeneration.elements.loadingSpinner).hide();
                    if (data.success) {
                        $('body').load(
                            '/api/sitecore/CinemaTickets/VoucherGeneratedSuccessModal',
                            function () {
                                $(codeGeneration.elements.codeGenerationSuccessModel).show();
                                let successModel = $(
                                    codeGeneration.elements.codeGenerationSuccessModel
                                ).html();
                                successModel =
                                    data.totalNumberOfVoucherCodes === 1
                                        ? successModel.replace(/{s}/g, '')
                                        : successModel.replace(/{s}/g, 's');
                                $(codeGeneration.elements.codeGenerationSuccessModel).html(
                                    successModel
                                );
                                const voucherType = data.voucherType;
                                codeGeneration.func.continueCodeGeneration.bindGeneratedCode(
                                    data
                                );
                                const redirectionUrl =
                                    voucherType.toLowerCase().indexOf('vue') !== -1
                                        ? data.vueLink
                                        : data.odeonLink;
                                $(codeGeneration.elements.copyCinemaCodeButton).attr(
                                    'href',
                                    redirectionUrl
                                );
                                $(codeGeneration.elements.copyCinemaCodeButton).on(
                                    'click',
                                    codeGeneration.func.gtm.pushBookOnlineEventDetails
                                );
                            }
                        );
                    } else {
                        codeGeneration.func.continueCodeGeneration.bindErrorModel(data);
                    }
                },

                bindErrorModel: function (data) {
                    if (codeGeneration.httpStatusCode.Unauthorised === data.errorCode) {
                        $(codeGeneration.elements.sessionTimeOutErrorModel).show();
                        $(codeGeneration.elements.sessionTimeOutErrorModelClose).on(
                            'click',
                            codeGeneration.func.helpers.reloadPage
                        );
                        $(codeGeneration.elements.sessionTimeOutErrorModelCloseButton).on(
                            'click',
                            codeGeneration.func.helpers.reloadPage
                        );
                    } else if (
                        codeGeneration.httpStatusCode.Forbidden === data.errorCode
                    ) {
                        window.location.replace(codeGeneration.urls.error);
                    } else {
                        $('#cinema-support-code').text(data.supportCode);
                        $(codeGeneration.elements.codeGenerationErrorModelClose).on(
                            'click',
                            codeGeneration.func.helpers.reloadPage
                        );
                        $(codeGeneration.elements.codeGenerationErrorModelCloseButton).on(
                            'click',
                            codeGeneration.func.helpers.reloadPage
                        );
                        $(codeGeneration.elements.codeGenerationErrorModel).show();
                    }
                },

                bindGeneratedCode: function (data) {
                    const voucherType = data.voucherType;
                    if (data.totalNumberOfVoucherCodes > 1) {
                        codeGeneration.func.continueCodeGeneration.multipleVoucherCodeBinding(
                            data
                        );
                    } else {
                        const voucherCodes =
                            data.currentMonthVoucherCodes.length === 0
                                ? data.previousMonthVoucherCodes
                                : data.currentMonthVoucherCodes;
                        codeGeneration.func.continueCodeGeneration.bindExpiryDate(
                            voucherCodes[0].voucherExpiry,
                            data.totalNumberOfVoucherCodes
                        );
                        codeGeneration.func.continueCodeGeneration.addGeneratedCodes(
                            voucherCodes,
                            data.totalNumberOfVoucherCodes,
                            voucherType
                        );
                    }
                },

                multipleVoucherCodeBinding: function (data) {
                    const voucherType = data.voucherType;
                    if (data.previousMonthVoucherCodes.length !== 0) {
                        codeGeneration.func.continueCodeGeneration.bindExpiryDate(
                            data.previousMonthVoucherCodes[0].voucherExpiry,
                            data.previousMonthVoucherCodes.length
                        );
                        codeGeneration.func.continueCodeGeneration.addGeneratedCodes(
                            data.previousMonthVoucherCodes,
                            data.totalNumberOfVoucherCodes,
                            voucherType
                        );
                    }
                    if (data.currentMonthVoucherCodes.length !== 0) {
                        codeGeneration.func.continueCodeGeneration.bindExpiryDate(
                            data.currentMonthVoucherCodes[0].voucherExpiry,
                            data.currentMonthVoucherCodes.length
                        );
                        codeGeneration.func.continueCodeGeneration.addGeneratedCodes(
                            data.currentMonthVoucherCodes,
                            data.totalNumberOfVoucherCodes,
                            voucherType
                        );
                    }
                },

                addGeneratedCodes: function (
                    voucherCodes,
                    totalNumberOfVoucherCodes,
                    voucherType
                ) {
                    let voucherCodeList = '';
                    let voucherCodeTemplate = '';
                    if (totalNumberOfVoucherCodes > 1) {
                        for (let i = 0; i < voucherCodes.length; i++) {
                            voucherCodeTemplate = $(
                                '#multiple-generated-code-template'
                            ).html();
                            voucherCodeTemplate = voucherCodeTemplate.replace(
                                '{vouchertype}',
                                voucherType
                            );
                            voucherCodeTemplate = voucherCodeTemplate.replace(
                                /VoucherCode/g,
                                voucherCodes[i].voucherCode
                            );
                            voucherCodeTemplate = voucherCodeTemplate.replace(
                                /count/g,
                                codeGeneration.availableVoucher
                            );
                            voucherCodeList = voucherCodeList + voucherCodeTemplate;
                            codeGeneration.availableVoucher++;
                        }
                        $(codeGeneration.elements.generatedCodesBody).append(
                            voucherCodeList
                        );
                        $('input[name=cinema-code]').on(
                            'change',
                            codeGeneration.func.continueCodeGeneration.changeCopycontent
                        );
                    } else {
                        voucherCodeTemplate = $('#single-generated-code-template').html();
                        voucherCodeTemplate = voucherCodeTemplate.replace(
                            '{vouchertype}',
                            voucherType
                        );
                        voucherCodeTemplate = voucherCodeTemplate.replace(
                            /VoucherCode/g,
                            voucherCodes[0].voucherCode
                        );
                        $(codeGeneration.elements.generatedCodesBody).append(
                            voucherCodeTemplate
                        );
                        $(codeGeneration.elements.copyCinemaCodeButton).attr(
                            'data-copycontent',
                            voucherCodes[0].voucherCode
                        );
                        $(codeGeneration.elements.copyCinemaCodeButton).removeClass(
                            codeGeneration.class.disableButton
                        );
                    }
                },

                getNumberOfVouchers: function () {
                    return $(codeGeneration.elements.numberOfTickets).val() === undefined
                        ? 1
                        : $(codeGeneration.elements.numberOfTickets).val();
                },

                bindExpiryDate: function (expiryDate, voucherCodesCount) {
                    let subHeadingTemplate = $(
                        '#generated-code-subheading-template'
                    ).html();
                    subHeadingTemplate = subHeadingTemplate.replace('{0}', expiryDate);
                    subHeadingTemplate =
                        voucherCodesCount > 1
                            ? subHeadingTemplate.replace(/{s}/g, 's')
                            : subHeadingTemplate.replace(/{s}/g, '');
                    subHeadingTemplate.replace(/{s}/g, '');
                    $(codeGeneration.elements.generatedCodesBody).append(
                        subHeadingTemplate
                    );
                },

                onError: function () {
                    window.location.replace(codeGeneration.urls.error);
                },

                getSelectedVoucherType: function () {
                    if ($(codeGeneration.elements.radioButton1).is(':checked')) {
                        return $(codeGeneration.elements.radioButton1).val();
                    } else if ($(codeGeneration.elements.radioButton2).is(':checked')) {
                        return $(codeGeneration.elements.radioButton2).val();
                    } else {
                        return '';
                    }
                },

                changeCopycontent: function () {
                    const value = $(this).val();
                    $(codeGeneration.elements.copyCinemaCodeButton).attr(
                        'data-copycontent',
                        value
                    );
                    $(codeGeneration.elements.copyCinemaCodeButton).removeClass(
                        codeGeneration.class.disableButton
                    );
                },

                isSubmissionValid: function () {
                    if (
                        ($(codeGeneration.elements.radioButton1).is(':checked') ||
                            $(codeGeneration.elements.radioButton2).is(':checked')) &&
                        $(codeGeneration.elements.numberOfTickets).val() !== 'Select number'
                    ) {
                        $(codeGeneration.elements.continueCodeGenerationButton).removeClass(
                            codeGeneration.class.disableButton
                        );
                        return true;
                    } else {
                        $(codeGeneration.elements.continueCodeGenerationButton).addClass(
                            codeGeneration.class.disableButton
                        );
                        return false;
                    }
                },
            },
            helpers: {
                reloadPage: function () {
                    window.location.reload(true);
                },
            },
            gtm: {
                pushFaqAccordionEventdetails: function () {
                    window.dataLayer.push({
                        event: 'accordionClick',
                        accordionType: 'Cinema-FAQ',
                        accordionTitle: $(this).attr('id'),
                    });
                },
                pushVoucerCodeAccordionEventDetails: function () {
                    window.dataLayer.push({
                        event: 'accordionClick',
                        accordionType: 'cinema-activeCodes',
                        accordionTitle: 'interacted',
                    });
                },
                pushGenerateCodeEventDetails: function () {
                    window.dataLayer.push({
                        event: 'cinemaCode',
                        stepCategory:
                            $(codeGeneration.elements.availableTicketCount).data('value') > 1
                                ? 'multiCode'
                                : 'singleCode',
                        stepTitle:
                            $(codeGeneration.elements.availableTicketCount).data('value') > 1
                                ? 'codeQuantity'
                                : 'cinemaSelection',
                        cinemaSelection:
                            codeGeneration.func.continueCodeGeneration.getSelectedVoucherType(),
                        value:
                            codeGeneration.func.continueCodeGeneration.getNumberOfVouchers(),
                    });
                },
                pushBookOnlineEventDetails: function () {
                    window.dataLayer.push({
                        event: 'cinemaCode',
                        stepCategory:
                            $(codeGeneration.elements.availableTicketCount).data('value') > 1
                                ? 'multiCode'
                                : 'singleCode',
                        stepTitle: 'bookOnline',
                    });
                },
            },
        },
    };
    return {
        codeGenerationInit: codeGeneration.func.init,
    };
})(jQuery);

$('document').ready(function () {
    if ('cinemav2' === $('#page-data').data('feature')) {
        cinema.codeGenerationInit();
    }
});
